import * as crypto from 'crypto'

const base58Alphabet = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'

function base58Decode(str) {
  const base = 58
  const alphabet = base58Alphabet
  const result = [0]

  for (let i = 0; i < str.length; i++) {
    let carry = alphabet.indexOf(str[i])
    if (carry === -1) return null

    for (let j = 0; j < result.length; j++) {
      carry += result[j] * base
      result[j] = carry & 0xff
      carry >>= 8
    }

    while (carry > 0) {
      result.push(carry & 0xff)
      carry >>= 8
    }
  }

  // Handle leading zeros
  for (let i = 0; i < str.length && str[i] === '1'; i++) {
    result.push(0)
  }

  return Buffer.from(result.reverse())
}

export function validateTRC20Address(address) {
  try {
    // Basic format checks
    if (!address || typeof address !== 'string') {
      return false
    }

    // Must start with 'T'
    if (!address.startsWith('T')) {
      return false
    }

    // Must be exactly 34 characters
    if (address.length !== 34) {
      return false
    }

    // Check if all characters are valid Base58
    for (let i = 0; i < address.length; i++) {
      if (!base58Alphabet.includes(address[i])) {
        return false
      }
    }

    // Decode the address
    const decoded = base58Decode(address)

    if (!decoded || decoded.length !== 25) {
      return false
    }

    // Extract payload and checksum
    const payload = decoded.slice(0, 21)
    const checksum = decoded.slice(21, 25)

    // Verify checksum using double SHA256
    const hash1 = crypto.createHash('sha256').update(payload).digest()
    const hash2 = crypto.createHash('sha256').update(hash1).digest()
    const calculatedChecksum = hash2.slice(0, 4)

    // Compare checksums
    return checksum.equals(calculatedChecksum)
  } catch (error) {
    return false
  }
}
